<div class="rounded-base border border-gray-200 shadow-sm flex flex-col cursor-pointer hover:shadow-md transition w-full h-full"
    (click)="openContract(document._id)">
    <div class="flex flex-col gap-3 flex-1 p-3 justify-between">
        <div class="flex flex-col gap-2">
            <div class="flex items-center gap-2 min-w-0"
                [ngClass]="document.documentStatus ? 'justify-between' : 'justify-end'">
                @if(document.documentStatus) {
                <div
                    class="rounded-base px-2 py-1 flex items-center justify-center truncate max-w-[6.25rem] theme-text-border flex-shrink-0">
                    <span class="theme-text truncate text-xs font-medium" tooltipPosition="bottom"
                        [pTooltip]="getDocumentStatusName(document)">{{ getDocumentStatusName(document) }}
                    </span>
                </div>
                }

                <!-- Right side - Status indicators and menu -->
                <div class="flex items-center gap-1 flex-shrink-0">
                    @if(showGenerationLoader) {
                    <div class="flex items-center justify-center w-8 h-8" (click)="$event.stopPropagation()">
                        <img src="icons/template-library/generation_in_progress.svg" alt="Generating"
                            class="w-4 h-4 animate-spin">
                    </div>
                    }
                    @else {
                    @if(dueDateExceeding || isPinned) {
                    <div class="flex items-center gap-2">
                        @if(dueDateExceeding) {
                        <i [innerHTML]="SVG.DUE_DATE_EXCEEDING | sanitizeHtml"
                            [attr.alt]="'Due Date Exceeding' | textCase" tooltipPosition="top"
                            [pTooltip]="'Overdue (' + (document.dueDate | date:'MMM d') + ')' | textCase"></i>
                        }
                        @if(isPinned) {
                        <i [innerHTML]="SVG.PINBOLD | sanitizeHtml" alt="Pinned" tooltipPosition="top"
                            pTooltip="Pinned"></i>
                        }
                    </div>
                    }

                    <!-- Show options only when current user is owner or editor -->
                    @if(menuOptions.length > 0){
                    @if(document.organization == currentUser.organization){
                    <div (click)="$event.stopPropagation()">
                        <app-menu #menu [items]="menuOptions" (itemSelected)="handleMenuSelection($event)"
                            (visibleChange)="onPopoverToggle($event)">
                            <i class="pi pi-ellipsis-v icon-sm p-0 m-0 cursor-pointer"
                                (click)="menu.toggle($event)"></i>
                        </app-menu>
                    </div>
                    }
                    }
                    }
                </div>

            </div>
            <div class="text-sm font-semibold text-gray-900 truncate-2-lines" tooltipPosition="bottom"
                [pTooltip]=" document.name ? document.name: ''">
                {{ document.name ? document.name: 'Untitled Document' }}
            </div>
        </div>

        <div class=" flex flex-row items-center gap-2">
            @if(showDocumentType) {
            <div class="flex items-center gap-1 max-w-[40%] min-w-0">
                <app-icon type="file-type" variant="muted"></app-icon>
                <span class="truncate text-xs text-gray-700" tooltipPosition="bottom"
                    [pTooltip]="document.linkedDocType && document.linkedDocType.name ? 'Document type: ' + document.linkedDocType.name : ''">{{
                    document.linkedDocType && document.linkedDocType.name ? document.linkedDocType.name : ''
                    }}</span>
            </div>
            }
            @if(showProjectName) {
            <div class="flex flex-row gap-1 items-center max-w-[60%] min-w-0">
                <app-icon type="folder-closed" variant="muted"></app-icon>
                @if(document.project && $any(document.project).name) {
                <span class="truncate text-xs text-gray-700" tooltipPosition="bottom"
                    [pTooltip]="'Project: ' + $any(document.project).name">{{
                    $any(document.project).name }}</span>
                } @else {
                <span class="text-xs text-gray-400 italic">{{'No project assigned'}}</span>
                }
            </div>
            }
        </div>


        @if(document.upcomingMilestone && document.upcomingMilestone.length > 0){
        <div class="flex items-center gap-2 text-xs text-gray-700 min-w-0">
            <i class="pi pi-flag icon-sm text-arena-orange-500 flex-shrink-0"></i>
            <span class="truncate min-w-0 text-gray-700" tooltipPosition="bottom"
                [pTooltip]="document.upcomingMilestone.length && document.upcomingMilestone[0].name ? 'Upcoming milestone: ' + document.upcomingMilestone[0].name : ''">{{
                document.upcomingMilestone.length && document.upcomingMilestone[0].name ?
                document.upcomingMilestone[0].name : '' }}</span>
            <span class="text-gray-300 flex-shrink-0 text-lg">•</span>
            <span class="rounded-base bg-arena-orange-100 text-arena-orange py-1 px-2 whitespace-nowrap flex-shrink-0"
                tooltipPosition="bottom"
                [pTooltip]="document.upcomingMilestone.length && document.upcomingMilestone[0].date ? 'Upcoming milestone date: ' + (document.upcomingMilestone[0].date | date: 'MMM d, YYYY') : ''">
                {{ document.upcomingMilestone.length && document.upcomingMilestone[0].date ?
                (document.upcomingMilestone[0].date | date: 'MMM d') : '' }}
            </span>
        </div>
        }@else {
        <div class="text-xs text-gray-700 italic flex items-center gap-1">
            <i class="pi pi-flag icon-sm text-gray-400"></i>
            <span class="text-gray-400 italic">{{'No upcoming milestones'}}</span>
        </div>
        }

        <div class="flex items-center gap-2 pt-2 text-xs border-t justify-between text-gray-500">
            <div class="flex gap-1 min-w-0 flex-1">
                <i class="pi pi-sync icon-xs leading-none text-gray-400 flex-shrink-0"></i>
                <span class="truncate leading-none"
                    [pTooltip]="'Last edited on ' + (document.updatedAt | dateFormatter: 'Do MMM') + (($any(document).updatedBy?.firstName || $any(document).createdBy?.firstName) ? ' by ' + ($any(document).updatedBy?.firstName || $any(document).createdBy?.firstName) + ' ' + ($any(document).updatedBy?.lastName || $any(document).createdBy?.lastName) : '')"
                    tooltipPosition="bottom">Last edited
                    <span class="text-gray-700">{{document.updatedAt | dateFormatter: 'Do MMM'}}</span>
                    @if($any(document).updatedBy?.firstName || $any(document).createdBy?.firstName) {
                    by <span class="text-gray-700">{{$any(document).updatedBy?.firstName ||
                        $any(document).createdBy?.firstName}} {{$any(document).updatedBy?.lastName ||
                        $any(document).createdBy?.lastName}}</span>
                    }
                </span>
            </div>

            <app-avatar-stack [users]="document.assignees ? document.assignees : []" [visibleAvatars]="2" size="xs">
            </app-avatar-stack>
        </div>
    </div>